import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { useState } from "react";
import MuiDialogContent from '@material-ui/core/DialogContent';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Container, Typography} from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useDispatch } from 'react-redux';  
import {updatePoStatus} from "../../redux/slices/purchassingOrder";
import {toast} from "react-toastify";

const useModalStyles = makeStyles((theme) => ({
    fontStyle :{fontWeight:'bold', fontFamily:'Times New Roman' },
    spaceStyle:{display:'flex', justifyContent:'space-between'},
    centerStyle:{textAlign:'center'},
    imageStyle:{width:"400px", height:"400px", float:"left"},
    contentStyle:{float:"left",  width:"450px"},
  }));

 

const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);
 
  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

//isFunction(setOpen) && setOpen(false)
export const ChangeStatusConfirm = (props) => {
    const classes = useModalStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const{open, setOpen, setParent, onClose, id} = props;

    function handleClose(){
        setOpen(false)
    }

    function handleDelete(){
        dispatch(updatePoStatus({
            data: {id:id,ActivityStatus: "Shipped", IsShipped: true}, onResolve: (type) => {
                setIsLoading(false)
                if(type==='failed')
                    toast.error('Error! check internet connection') 
                if(type==='done')
                    toast.success('Updated Done')  
                handleClose()
            }
        }))
        setParent(false)
        onClose && onClose()
    }


    return (
        <div>
        <Dialog fullWidth maxWidth="sm" onClose={handleClose} 
                aria-labelledby="customized-dialog-title" open={open}>

            <DialogActions style={{justifyContent:"center"}}>
                <Typography align="center">
                    Vous êtes certains de vouloir changer le Status de ce PO ?
                </Typography>
            </DialogActions>

            <DialogContent>
                <Container maxWidth="lg" className={classes.spaceStyle}>
                        <Button  color="secondary" 
                                onClick={()=> handleDelete()}
                                variant="contained">
                            Oui, continuer
                        </Button>
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            Non, annuler
                        </Button>
                </Container>
            </DialogContent>

        </Dialog>
      </div>
    )
}
